import React, { Fragment, useContext, useEffect, useState, useRef,} from "react";
import { getPayrollYears, getPayrollMonthsByYear, getPayrollListByMonth, downloadReportCedolini, downloadReportCedoliniV2, confirmEmpDoc, deleteEmpDoc, deleteBusta,} from "../services/api";
import { ReassignDialog, confirmAll, deleteAll } from "./confirm";
import { estraiMessaggiErrore } from "../services/utils";
import { Link } from "wouter";
import moment from "moment";
import Swal from "sweetalert2";
import { months } from "../config";
import { MessageContext } from "../contexts/message";
import { confirmAllEmpDocs, deleteAllEmpDocs } from "../services/api";
import Fetching from "./fetching";
import LoadingState from "./fetchingV2";
import FilePreviewModal from "./preview_modal";
import CustomTooltipComponent from "./custom_tooltip_component";
import { CheckCircleIcon, PaperClipIcon, XCircleIcon, CheckIcon, TrashIcon, MagnifyingGlassIcon,} from "@heroicons/react/24/outline";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PrettyPagination from "./pretty_pagination";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { useLocation } from "wouter";

// ---------------------------------------------------------
// UTILS
// ---------------------------------------------------------
function isAbortError(err) {
  if (!err) return false;
  if (err.name === "AbortError") return true;
  if (err?.cause?.name === "AbortError") return true;
  if (err.name === "CanceledError") return true;
  if (err.code === "ERR_CANCELED") return true;
  if (
    typeof err.message === "string" &&
    err.message.toLowerCase().includes("canceled")
  ) {
    return true;
  }
  if (err.aborted === true) return true;
  return false;
}


// PayrollSearchAndPills.jsx (o nello stesso file)

function PayrollSearchAndPills({
  headerLabel,
  search,
  setSearch,
  setPage,

  total,
  showOnlyTotal,
  toConfirm,
  confirmed,
}) {
  return (
    <div className="space-y-3">
      {headerLabel ? (
        <div className="shadow-md bg-indigo-200 text-indigo-800 flex justify-center text-lg font-semibold py-4 rounded-lg">
          {headerLabel}
        </div>
      ) : null}

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 px-3 py-3">
        <TextField
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage?.(1);
          }}
          placeholder="Cerca per cognome, nome o CF"
          size="small"
          fullWidth
          variant="outlined"
          sx={{
            "& .MuiInputLabel-root": { color: "#6b7280" },
            "&:hover .MuiInputLabel-root": { color: "#4338ca" },
            "& .MuiInputBase-input-MuiOutlinedInput-input": { color: "#4338ca" },
            "& .MuiInputLabel-root.Mui-focused": { color: "#4338ca" },
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
              backgroundColor: "#f9fafb",
              height: 40,
            },
            "& .MuiOutlinedInput-notchedOutline": { borderColor: "#c7d2fe", borderWidth: "1px" },
            "& .MuiOutlinedInput-root:hover fieldset": { borderColor: "#818cf8", borderWidth: "1px" },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#e5e7eb",
              borderWidth: "1px",
            },
            "& .MuiOutlinedInput-input, & .MuiOutlinedInput-input:focus, & .MuiOutlinedInput-input:focus-visible": {
              outline: "none",
              boxShadow: "none",
            },
            "& .MuiOutlinedInput-root:focus-within": { outline: "none", boxShadow: "none" },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        <div className="mt-3 flex flex-wrap gap-2 uppercase">
          {total > 0 && (
            <div className="inline-flex items-center gap-2 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-100 px-3 py-1 text-xs font-semibold">
              <span className="w-2 h-2 rounded-full bg-indigo-500" />
              caricati: <span className="font-bold">{total}</span>
            </div>
          )}

          {!showOnlyTotal && (
            <>
              <div className="inline-flex items-center gap-2 rounded-full bg-red-50 text-red-700 border border-red-100 px-3 py-1 text-xs font-semibold">
                <span className="w-2 h-2 rounded-full bg-red-500" />
                da confermare: <span className="font-bold">{toConfirm}</span>
              </div>

              <div className="inline-flex items-center gap-2 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-100 px-3 py-1 text-xs font-semibold">
                <span className="w-2 h-2 rounded-full bg-emerald-500" />
                confermati: <span className="font-bold">{confirmed}</span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

// PayrollFooterActions.jsx (o nello stesso file)
function PayrollFooterActions({
  selectedYear,
  selectedMonth,
  anyToConfirm,
  fetchingReport,
  downloadReport,
  handleConfirmAllDocs,
  handleDeleteAllDocs,
}) {
  if (!selectedYear || !selectedMonth) return null;

  return (
    <div className="mt-3 bg-white rounded-lg shadow-sm border border-gray-200 p-3">
      {fetchingReport ? (
        <div className="flex items-center justify-center italic text-sm">
          Downloading...
        </div>
      ) : (
        <div className="flex flex-wrap items-center justify-center gap-3">
          <button
            onClick={downloadReport}
            type="button"
            className="
              w-40 max-w-40
              inline-flex items-center justify-center gap-x-1.5
              rounded-md bg-indigo-600
              px-3 py-2 text-sm font-semibold text-white
              shadow-sm hover:bg-indigo-500
            "
          >
            Stampa Report
            <PaperClipIcon className="h-5 w-5" />
          </button>

          {anyToConfirm && (
            <>
              <button
                onClick={handleConfirmAllDocs}
                type="button"
                className="
                  w-40 max-w-40
                  inline-flex items-center justify-center gap-x-1.5
                  rounded-md bg-green-600
                  px-3 py-2 text-sm font-semibold text-white
                  shadow-sm hover:bg-green-500
                "
              >
                Conferma
                <CheckIcon className="h-5 w-5" />
              </button>

              <button
                onClick={handleDeleteAllDocs}
                type="button"
                className="
                  w-40 max-w-40
                  inline-flex items-center justify-center gap-x-1.5
                  rounded-md bg-red-600
                  px-3 py-2 text-sm font-semibold text-white
                  shadow-sm hover:bg-red-500
                "
              >
                Cancella
                <TrashIcon className="h-5 w-5" />
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}


// ---------------------------------------------------------
// SUBCOMPONENT MOBILE
// ---------------------------------------------------------
function MonthBusteMobile({
  year,
  month,
  monthLabel,

  // lista
  buste,
  openPayrollId,
  toggleRow,
  setSelectedDoc,
  handleConfirmDoc,
  handleDeleteDoc,
  deletePayrollConfirmed,
  setPreviewDoc,
  loadingBuste,

  // paging + search
  page,
  totalPages,
  totalCount,
  onPageChange,
  search,
  setSearch,

  // pills
  total,
  showOnlyTotal,
  toConfirm,
  confirmed,

  // footer actions
  anyToConfirm,
  fetchingReport,
  downloadReport,
  handleConfirmAllDocs,
  handleDeleteAllDocs,

  // icone
  PaperClipIcon,
  CheckIcon,
  TrashIcon,
}) {
  if (!year || !month) return null;

  const headerLabel = `${year} - ${monthLabel}`;

  return (
    <div className="mt-2 mb-4 block xl:hidden">
      {/* TOP: header + search + pills */}
      <PayrollSearchAndPills
        headerLabel={headerLabel}
        search={search}
        setSearch={setSearch}
        setPage={onPageChange}
        total={total}
        showOnlyTotal={showOnlyTotal}
        toConfirm={toConfirm}
        confirmed={confirmed}
      />

      {/* LISTA */}
      <div className="flex flex-col mt-2">
        <div className="align-middle min-w-full overflow-x-auto shadow overflow-hidden sm:rounded-lg">
          {loadingBuste ? (
            <div className="w-full flex justify-center items-center">
              <Fetching />
            </div>
          ) : (
            <>
              <ul role="list" className="divide-y divide-gray-100">
                {buste.map((busta) => (
                  <PayrollRow
                    key={busta.id}
                    busta={{ ...busta, mese: busta.month, anno: busta.year }}
                    isOpen={openPayrollId === busta.id}
                    onToggle={() => toggleRow(busta.id)}
                    onReassign={() =>
                      setSelectedDoc({
                        id: busta.id,
                        type: "payrolls",
                        employee: {
                          cf: busta.employee_cf,
                          first_name: busta.employee_first_name,
                          last_name: busta.employee_last_name,
                          name:
                            `${busta.employee_last_name || ""} ${busta.employee_first_name || ""}`.trim() ||
                            busta.employee_cf,
                        },
                      })
                    }
                    onConfirm={() => handleConfirmDoc({ id: busta.id, type: "payrolls" })}
                    onDeleteUnconfirmed={() => handleDeleteDoc({ id: busta.id, type: "payrolls" })}
                    onDeleteConfirmed={() => deletePayrollConfirmed(busta.id)}
                    setPreviewDoc={setPreviewDoc}
                  />
                ))}
              </ul>

              <PrettyPagination
                page={page}
                totalPages={totalPages}
                totalCount={totalCount}
                onChange={onPageChange}
                labelSingolare="cedolino"
                labelPlurale="cedolini"
                className="mt-3 py-3 border border-t border-gray-200 bg-gray-50"
              />

              {/* BOTTOM: actions */}
              <PayrollFooterActions
                selectedYear={year}
                selectedMonth={month}
                anyToConfirm={anyToConfirm}
                fetchingReport={fetchingReport}
                downloadReport={downloadReport}
                handleConfirmAllDocs={handleConfirmAllDocs}
                handleDeleteAllDocs={handleDeleteAllDocs}
                PaperClipIcon={PaperClipIcon}
                CheckIcon={CheckIcon}
                TrashIcon={TrashIcon}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ---------------------------------------------------------
// ROW COMPONENT
// ---------------------------------------------------------
function PayrollRow({
  busta,
  isOpen,
  onToggle,
  onReassign,
  onConfirm,
  onDeleteUnconfirmed,
  onDeleteConfirmed,
  setPreviewDoc,
}) {
  const handleDeleteClick = () => {
    if (busta.is_confirmed) {
      onDeleteConfirmed?.();
    } else {
      onDeleteUnconfirmed?.();
    }
  };

  return (
    <>
      <li
        className={`flex items-center cursor-pointer justify-between gap-x-6 px-5 py-2 ${
          busta.is_confirmed ? "" : "bg-red-50"
        }`}
        onClick={onToggle}
      >
        <div className="min-w-0">
          <div className="flex items-start gap-x-3">
            <button
              onClick={(e) => {
                e.stopPropagation();
                onToggle();
              }}
            >
              {isOpen ? (
                <KeyboardArrowUpIcon className="w-5 h-5" />
              ) : (
                <KeyboardArrowDownIcon className="w-5 h-5" />
              )}
            </button>

            <CustomTooltipComponent title="Vai all'anagrafica">
              <>
                <Link
                  to={`/dipendenti/${busta.employee_cf}`}
                  onClick={(e) => e.stopPropagation()}
                  className="inline-flex flex-col text-left hover:text-indigo-600 hover:underline"
                >
                  <span className="font-medium text-sm text-gray-900">
                    {busta.employee_last_name || busta.employee_first_name
                      ? `${busta.employee_last_name || ""} ${
                          busta.employee_first_name || ""
                        }`.trim()
                      : busta.employee_cf}
                  </span>

                  {(busta.employee_last_name ||
                    busta.employee_first_name) && (
                    <span className="text-xs text-gray-500">
                      {busta.employee_cf}
                    </span>
                  )}
                </Link>
              </>
            </CustomTooltipComponent>
          </div>

          <ul className="mt-1 flex flex-wrap gap-x-4 text-xs text-gray-500 pl-8">
            <li className="flex items-center gap-x-1">
              Confermata:
              {busta.is_confirmed ? (
                <CheckCircleIcon className="h-4 w-4 text-green-500" />
              ) : (
                <XCircleIcon className="h-4 w-4 text-red-500" />
              )}
            </li>

            <li className="flex items-center gap-x-1">
              Letta:
              {busta.read_at ? (
                <>
                  <CheckCircleIcon className="h-4 w-4 text-green-500" />
                  {moment(busta.read_at).format("DD/MM/YYYY HH:mm")}
                </>
              ) : (
                <>
                  <XCircleIcon className="h-4 w-4 text-red-500" />
                  <span className="text-red-500">Non letta</span>
                </>
              )}
            </li>
          </ul>
        </div>

        <div className="flex items-center gap-1 shrink-0">
          {!busta.is_confirmed && (
            <>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onReassign();
                }}
                className="inline-flex items-center rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              >
                Riassegna
              </button>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onConfirm();
                }}
                className="inline-flex items-center rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 me-2"
              >
                Conferma
              </button>
            </>
          )}

          <CustomTooltipComponent title="Apri anteprima">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setPreviewDoc({
                  url: busta.download_link,
                  name: `${String(busta.mese).padStart(
                    2,
                    "0"
                  )} / ${busta.anno}`,
                });
              }}
              className="inline-flex items-center pe-3 text-indigo-600 hover:underline"
            >
              <MagnifyingGlassIcon className="h-5 w-5" />
            </button>
          </CustomTooltipComponent>

          <CustomTooltipComponent title="Elimina">
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteClick();
              }}
              className="action-btn text-gray-700 hover:text-red-600"
            >
              <TrashIcon className="h-5 w-5" />
            </button>
          </CustomTooltipComponent>
        </div>
      </li>

      {isOpen && (
        <div className="bg-gray-50 px-6 py-4 text-sm shadow-lg border border-gray-300 mx-6 mb-4 mt-4">
          <dl className="grid grid-cols-12 gap-x-4 gap-y-1 items-center">
            <dt className="col-span-2 font-semibold">File</dt>
            <dd className="col-span-10">
              <button
                type="button"
                onClick={() =>
                  setPreviewDoc({
                    url: busta.download_link,
                    name: `${String(busta.mese).padStart(
                      2,
                      "0"
                    )} / ${busta.anno}`,
                  })
                }
                className="inline-flex items-center gap-1 text-indigo-600 hover:underline"
              >
                <MagnifyingGlassIcon className="h-4 w-4" />
                <span>Apri anteprima</span>
              </button>
            </dd>

            <dt className="col-span-2 font-semibold">Caricato</dt>
            <dd className="col-span-10">
              {moment(busta?.created_at).format("DD/MM/YYYY HH:mm")}
            </dd>

            <dt className="col-span-2 font-semibold">Mese</dt>
            <dd className="col-span-10">
              {String(busta.mese).padStart(2, "0")}
            </dd>

            <dt className="col-span-2 font-semibold">Anno</dt>
            <dd className="col-span-10">{busta.anno}</dd>

            <dt className="col-span-2 font-semibold">Status</dt>
            <dd className="col-span-10 inline-flex items-center gap-2">
              {busta.is_confirmed ? (
                <>
                  <CheckCircleIcon className="h-4 w-4 text-green-500" />
                  <span className="text-green-600">Confermata</span>
                </>
              ) : (
                <>
                  <XCircleIcon className="h-4 w-4 text-red-500" />
                  <span className="text-red-500">Non confermata</span>
                </>
              )}
            </dd>

            <dt className="col-span-2 font-semibold">Letto</dt>
            <dd className="col-span-10 inline-flex items-center gap-2">
              {busta.read_at ? (
                <>
                  <CheckCircleIcon className="h-4 w-4 text-green-500" />
                  {moment(busta.read_at).format("DD/MM/YYYY HH:mm")}
                </>
              ) : (
                <>
                  <XCircleIcon className="h-4 w-4 text-red-500" />
                  <span className="text-red-500">Non letta</span>
                </>
              )}
            </dd>
          </dl>
        </div>
      )}
    </>
  );
}

// ---------------------------------------------------------
// COMPONENTE PRINCIPALE
// ---------------------------------------------------------
export default function V2BusteTable({ loading, token }) {
  const message = useContext(MessageContext);

  // ---- STATE ----
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);

  // dati caricati
  const [monthsData, setMonthsData] = useState([]); // mesi dell'anno selezionato
  const [busteData, setBusteData] = useState([]); // buste del (selectedYear, selectedMonth)

  const [fetchingYears, setFetchingYears] = useState(false);
  const [fetchingReport, setFetchingReport] = useState(false);

  const [openPayrollId, setOpenPayrollId] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [previewDoc, setPreviewDoc] = useState(null);

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [globalTotal, setGlobalTotal] = useState(0);
  const [confirmedCount, setConfirmedCount] = useState(0);
  const [toConfirmCount, setToConfirmCount] = useState(0);
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

  const [loadingMonths, setLoadingMonths] = useState(false);
  const [loadingBuste, setLoadingBuste] = useState(false);

  const [location, setLocation] = useLocation();

  const total = Number(globalTotal ?? 0);
  const confirmed = Number(confirmedCount ?? 0);
  const toConfirm = Number(toConfirmCount ?? 0);

  // ---- ABORT + REQUEST IDS ----
  const monthsControllerRef = useRef(null);
  const busteControllerRef = useRef(null);
  const monthsReqIdRef = useRef(0);
  const busteReqIdRef = useRef(0);

  const pageRef = useRef(page);
  const busteLenRef = useRef(busteData.length);

  useEffect(() => { pageRef.current = page; }, [page]);
  useEffect(() => { busteLenRef.current = busteData.length; }, [busteData.length]);

  const showOnlyTotal = total > 0 && toConfirm === 0 && confirmed === total;

  const pendingNavRef = useRef({ year: null, month: null, applied: false });

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(search.trim()), 350);
    return () => clearTimeout(t);
  }, [search]);

  useEffect(() => {
    setPage(1);
  }, [selectedYear, selectedMonth, debouncedSearch]);

  useEffect(() => {
    if (!location) return;

    const params = new URLSearchParams(window.location.search);
    const year = Number(params.get("year"));
    const month = Number(params.get("month"));
        
    if (!year || !month) return;

    pendingNavRef.current = { year, month, applied: false };
    setSelectedYear(year);

    // ripulisci URL
    setLocation("/buste", { replace: true });
  }, [location, setLocation]);

  function abortMonthsRequest() {
    if (monthsControllerRef.current) {
      monthsControllerRef.current.abort();
      monthsControllerRef.current = null;
    }
  }
  function abortBusteRequest() {
    if (busteControllerRef.current) {
      busteControllerRef.current.abort();
      busteControllerRef.current = null;
    }
  }
  function abortAllRequests() {
    abortMonthsRequest();
    abortBusteRequest();
  }

  const anyToConfirm = busteData?.some((b) => !b.is_confirmed) || false;
  const toggleRow = (id) =>
    setOpenPayrollId((prev) => (prev === id ? null : id));

  // ---- HELPERS ----
  const handleDownloadBlob = (blob, year, month) => {
    if (!(blob instanceof Blob)) return;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `report-${year}-${month}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // ---- EFFECT 1: anni ----
  useEffect(() => {
    if (!token) return;
    if (years.length > 0) return;

    (async () => {
      setFetchingYears(true);
      try {
        const controller = new AbortController();
        const data = await getPayrollYears(
          token,
          controller.signal,
          "payrolls",
          null
        );

        setYears(Array.isArray(data) ? data : []);

        const pendingYear = pendingNavRef.current?.year;

        if (data && data.length > 0) {
          if (pendingYear && data.some((x) => x.year === pendingYear)) {
            setSelectedYear(pendingYear);
          } else if (!selectedYear) {
            setSelectedYear(data[0].year);
          }
        }
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Errore",
          text: "Errore nel caricamento anni",
        });
      } finally {
        setFetchingYears(false);
      }
    })();
  }, [token, years.length, selectedYear]);

  // ---- EFFECT 2: mesi per selectedYear ----
  useEffect(() => {
    if (!token) return;
    if (!selectedYear) return;

    // Cambiare anno invalida mesi e buste precedenti => abort vecchie richieste
    abortAllRequests();

    const controller = new AbortController();
    monthsControllerRef.current = controller;
    const reqId = ++monthsReqIdRef.current;

    // snapshot per evitare race
    const yearSnapshot = Number(selectedYear);

    setLoadingMonths(true);
    setLoadingBuste(false);
    setMonthsData([]);
    setBusteData([]);

    (async () => {
      try {
        const data = await getPayrollMonthsByYear(
          token,
          yearSnapshot,
          controller.signal,
          "payrolls",
          null
        );

        // se non è più la richiesta valida, esci
        if (reqId !== monthsReqIdRef.current) return;
        // se l'utente ha cambiato anno nel frattempo, esci
        if (Number(selectedYear) !== yearSnapshot) return;

        const ordered = Array.isArray(data) ? data : [];
        setMonthsData(ordered);

        // mese desiderato: prima dalla navigation intent, poi dal valore corrente
        const pending = pendingNavRef.current;
        const pendingMonth =
          pending?.year === yearSnapshot ? Number(pending?.month) : null;

        const desiredMonth =
          pendingMonth ?? (selectedMonth ? Number(selectedMonth) : null);

        // se il mese desiderato esiste, usa quello e marca applied
        if (
          desiredMonth &&
          ordered.some((m) => Number(m.month) === Number(desiredMonth))
        ) {
          setSelectedMonth(Number(desiredMonth));
          if (pendingMonth) pendingNavRef.current = { ...pending, applied: true };
          return;
        }

        // fallback standard: primo mese disponibile
        if (ordered.length > 0) {
          setSelectedMonth(Number(ordered[0].month));
        } else {
          setSelectedMonth(null);
          setBusteData([]);
        }
      } catch (err) {
        if (!isAbortError(err)) {
          Swal.fire({
            icon: "error",
            title: "Errore",
            text: "Errore nel caricamento mesi",
          });
        }
      } finally {
        if (reqId === monthsReqIdRef.current) setLoadingMonths(false);
        if (monthsControllerRef.current === controller) monthsControllerRef.current = null;
      }
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedYear, token]);

  // ---- EFFECT 3: buste per (selectedYear, selectedMonth) ----
  useEffect(() => {
    if (!token) return;
    if (!selectedYear || !selectedMonth) return;

    abortBusteRequest();

    const controller = new AbortController();
    busteControllerRef.current = controller;
    const reqId = ++busteReqIdRef.current;
    const yearSnapshot = selectedYear;
    const monthSnapshot = selectedMonth;
    const pageSnapshot = page;
    const searchSnapshot = debouncedSearch;

    setLoadingBuste(true);

    (async () => {
      try {
        const resp = await getPayrollListByMonth(
          token,
          yearSnapshot,
          monthSnapshot,
          controller.signal,
          "payrolls",
          null,
          {
            page: pageSnapshot,
            page_size: pageSize,
            search: searchSnapshot || undefined,
          }
        );

        if (reqId !== busteReqIdRef.current) return;
        if (selectedYear !== yearSnapshot || selectedMonth !== monthSnapshot) return;

        const list = resp?.results || [];
        setBusteData(list);
        setTotalCount(Number(resp?.count ?? 0));
        setGlobalTotal(Number(resp?.global_total ?? 0));
        setConfirmedCount(Number(resp?.confirmed_count ?? 0));
        setToConfirmCount(Number(resp?.to_confirm_count ?? 0));
      } catch (err) {
        if (!isAbortError(err)) {
          Swal.fire({
            icon: "error",
            title: "Errore",
            text: estraiMessaggiErrore(err) ||
            "Errore nel caricamento delle buste",
          });
        }
      } finally {
        if (reqId === busteReqIdRef.current) {
          setLoadingBuste(false);
        }
        if (busteControllerRef.current === controller) {
          busteControllerRef.current = null;
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedYear, selectedMonth, token, page, debouncedSearch, pageSize]);

  // ---- ACTIONS ----

  const refetchYears = async () => {
    const controller = new AbortController();
    const data = await getPayrollYears(token, controller.signal, "payrolls", null);
    const arr = Array.isArray(data) ? data : [];
    setYears(arr);

    if (arr.length === 0) {
      setSelectedYear(null);
      setSelectedMonth(null);
      setMonthsData([]);
      setBusteData([]);
      setTotalCount(0);
      setGlobalTotal(0);
      setConfirmedCount(0);
      setToConfirmCount(0);
    } else {
      // se l'anno corrente non esiste più, fallback al primo
      const stillExists = arr.some((y) => Number(y.year) === Number(selectedYear));
      if (!stillExists) {
        setSelectedYear(arr[0].year);
        setSelectedMonth(null);
      }
    }
  };

  const refetchMonths = async (year = selectedYear) => {
    if (!token || !year) return null;

    abortMonthsRequest();
    const controller = new AbortController();
    monthsControllerRef.current = controller;
    const reqId = ++monthsReqIdRef.current;

    setLoadingMonths(true);

    try {
      const data = await getPayrollMonthsByYear(
        token,
        Number(year),
        controller.signal,
        "payrolls",
        null
      );

      if (reqId !== monthsReqIdRef.current) return null;

      const ordered = Array.isArray(data) ? data : [];
      setMonthsData(ordered);

      // mese corrente ancora valido?
      const current = Number(selectedMonth);
      const stillExists = ordered.some((m) => Number(m.month) === current);

      if (stillExists) return current;

      if (ordered.length > 0) {
        const fallback = Number(ordered[0].month);
        setSelectedMonth(fallback);
        return fallback;
      }

      // nessun mese rimasto in quell'anno
      setSelectedMonth(null);
      setBusteData([]);
      setTotalCount(0);
      setGlobalTotal(0);
      setConfirmedCount(0);
      setToConfirmCount(0);
      return null;
    } finally {
      if (reqId === monthsReqIdRef.current) setLoadingMonths(false);
      if (monthsControllerRef.current === controller) monthsControllerRef.current = null;
    }
  };
  
  const fetchBuste = async ({
    year,
    month,
    page: requestedPage = 1,
    search: searchValue = debouncedSearch || undefined,
    signal,
  } = {}) => {
    const y = Number(year ?? selectedYear);
    const m = Number(month ?? selectedMonth);

    if (!token || !y || !m) return null;

    const resp = await getPayrollListByMonth(
      token,
      y,
      m,
      signal,
      "payrolls",
      null,
      {
        page: requestedPage,
        page_size: pageSize,
        search: searchValue,
      }
    );

    return resp;
  };

  const applyBusteResponse = (resp) => {
    const list = Array.isArray(resp?.results) ? resp.results : [];
    setBusteData(list);
    setTotalCount(Number(resp?.count ?? 0));
    setGlobalTotal(Number(resp?.global_total ?? 0));
    setConfirmedCount(Number(resp?.confirmed_count ?? 0));
    setToConfirmCount(Number(resp?.to_confirm_count ?? 0));
  };

  const refetchCurrentBuste = async ({
    year,
    month,
    page: requestedPage = pageRef.current,
  } = {}) => {
    if (!token) return;

    setLoadingBuste(true);
    abortBusteRequest();

    const controller = new AbortController();
    busteControllerRef.current = controller;
    const reqId = ++busteReqIdRef.current;

    const y = Number(year ?? selectedYear);
    const m = Number(month ?? selectedMonth);

    try {
      const resp = await fetchBuste({
        year: y,
        month: m,
        page: requestedPage,
        signal: controller.signal,
      });

      if (reqId !== busteReqIdRef.current) return;

      applyBusteResponse(resp);

      // allinea pagina state
      if (requestedPage !== pageRef.current) setPage(requestedPage);

      return resp;
    } catch (err) {
      if (isAbortError(err)) return;

      const detail = err?.response?.data?.detail;
      const isInvalidPage =
        typeof detail === "string" && detail.toLowerCase().includes("invalid page");

      if (isInvalidPage && requestedPage > 1) {
        return await refetchCurrentBuste({ year: y, month: m, page: requestedPage - 1 });
      }

      Swal.fire({
        icon: "error",
        title: "Errore",
        text: estraiMessaggiErrore(err) || "Errore, riprova più tardi.",
      });
    } finally {
      if (reqId === busteReqIdRef.current) setLoadingBuste(false);
      if (busteControllerRef.current === controller) busteControllerRef.current = null;
    }
  };

  const refreshAfterDelete = async ({ removedCount = 1 } = {}) => {
    // se non ho contesto mese/anno, esco
    if (!token || !selectedYear || !selectedMonth) return;

    const currentPage = pageRef.current;
    const currentLen = busteLenRef.current;

    // Se ho rimosso tutto ciò che vedevo in pagina (tipico: ultimo elemento), e non sono in pagina 1,
    // provo a tornare indietro di 1 pagina.
    const willBeEmpty = currentLen - removedCount <= 0;

    const targetPage = willBeEmpty ? Math.max(1, currentPage - 1) : currentPage;

    // Aggiorna subito lo state (UI coerente)
    setPage(targetPage);

    // Ricarica forzando quella pagina (così non aspetti l'effect)
    await refetchCurrentBuste({ page: targetPage });
  };

  const handleConfirmAllDocs = async () => {
    try {
      if (!selectedYear || !selectedMonth) return;

      const year = selectedYear;
      const month = selectedMonth;

      const meseAnno = `${String(month).padStart(2, "0")}/${year}`;

      const res = await Swal.fire({
        title: "Conferma documenti",
        text: `Vuoi confermare tutte le buste paga del periodo ${meseAnno}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sì, conferma",
        cancelButtonText: "Annulla",
        cancelButtonColor: "#6b7280",
      });

      if (!res.isConfirmed) return;

      await confirmAllEmpDocs(token, { year, month }, "payrolls");

      await Swal.fire({
        title: "Operazione completata",
        text: "Confermate con successo",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#4f46e5",
      });


      const newTotalPages = Math.max(1, Math.ceil((totalCount - 1) / pageSize)); 
      if (page > newTotalPages) setPage(newTotalPages);

      await refetchCurrentBuste();
      await refetchMonths();
      await refetchYears();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Errore",
        text: estraiMessaggiErrore(error) || "Errore, riprova più tardi.",
        confirmButtonText: "OK",
      });
    }
  };

  const handleDeleteAllDocs = async () => {
    try {
      if (!selectedYear || !selectedMonth) return;

      const year = Number(selectedYear);
      const month = Number(selectedMonth);
      const meseAnno = `${String(month).padStart(2, "0")}/${year}`;

      const res = await Swal.fire({
        title: "Elimina documenti",
        text: `Vuoi eliminare tutte le buste paga NON confermate del periodo ${meseAnno}? Questa azione è irreversibile.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sì, elimina",
        cancelButtonText: "Annulla",
        confirmButtonColor: "#dc2626",
        cancelButtonColor: "#6b7280",
        reverseButtons: true,
      });
      if (!res.isConfirmed) return;

      await deleteAllEmpDocs(token, { year, month }, "payrolls");

      await Swal.fire({
        title: "Operazione completata",
        text: "Cancellate con successo",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#4f46e5",
      });

      // 1) riallineo mesi (e ottengo il mese valido)
      const nextMonth = await refetchMonths(year);

      // 2) riallineo anni (può annullare selectedYear)
      await refetchYears();

      // se non c'è più nessun mese, fine (UI vuota corretta)
      if (!nextMonth) {
        setPage(1);
        return;
      }

      // IMPORTANTISSIMO:
      // carico usando year + nextMonth espliciti (non lo state che può aggiornarsi dopo)
      setPage(1);
      await refetchCurrentBuste({ year, month: nextMonth, page: 1 });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Errore",
        text: estraiMessaggiErrore(error) || "Errore, riprova più tardi.",
        confirmButtonText: "OK",
      });
    }
  };

  const handleConfirmDoc = async (doc) => {
    try {
      await confirmEmpDoc(token, doc.id, doc.type);
      await Swal.fire({
        title: "Operazione completata",
        text: "Confermato con successo",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });


      await refetchCurrentBuste();
      await refetchMonths();
      await refetchYears();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Errore",
        text:
          estraiMessaggiErrore(error) || "Errore, riprova più tardi.",
        confirmButtonText: "OK",
      });
    }
  };

  const handleDeleteDoc = async (doc) => {
    Swal.fire({
      title: "Sei sicuro di voler cancellare questo file?",
      text: "Una volta cancellato non sarai in grado di recuperarlo!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sì, elimina",
      cancelButtonText: "Annulla",
      cancelButtonColor: "#a3a3a3",
    }).then(async ({ isConfirmed }) => {
      if (!isConfirmed) return;

      try {
        await deleteEmpDoc(token, doc.id, doc.type);

        await refreshAfterDelete({ removedCount: 1 });
        await refetchMonths();
        await refetchYears();

        Swal.fire({
          icon: "success",
          title: "File cancellato con successo",
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Errore",
          text:
            estraiMessaggiErrore(error) || "Errore, riprova più tardi.",
          confirmButtonText: "OK",
        });
      }
    });
  };

  const deletePayrollConfirmed = (payrollId) => {
    Swal.fire({
      title: "Sei sicuro di voler cancellare questo file?",
      text: "Una volta cancellato non sarai in grado di recuperarlo!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sì, elimina",
      cancelButtonText: "Annulla",
      cancelButtonColor: "#a3a3a3",
    }).then(async ({ isConfirmed }) => {
      if (!isConfirmed) return;

      try {
        await deleteBusta(token, payrollId);

        await refreshAfterDelete({ removedCount: 1 });


        Swal.fire({
          icon: "success",
          title: "File cancellato con successo",
          timer: 1500,
          showConfirmButton: false,
        });

        await refetchMonths();
        await refetchYears();
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Errore",
          text:
            estraiMessaggiErrore(err) || "Errore, riprova più tardi.",
        });
      }
    });
  };

  const downloadReport = async () => {
    setFetchingReport(true);

    try {
      const year = selectedYear;
      const month = selectedMonth;

      const result = await Swal.fire({
        title: "Scegli il tipo di stampa",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText:
          "Stampa senza data di conferma documento",
        denyButtonText: `Stampa con data di conferma documento`,
        denyButtonColor: "#7066e0",
      });

      if (result.isConfirmed) {
        const blob = await downloadReportCedolini(token, year, month);
        handleDownloadBlob(blob, year, month);
      } else if (result.isDenied) {
        const blob = await downloadReportCedoliniV2(
          token,
          year,
          month
        );
        handleDownloadBlob(blob, year, month);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Errore",
        text:
          estraiMessaggiErrore(error) || "Errore, riprova più tardi.",
      });
    } finally {
      setFetchingReport(false);
    }
  };

  // ---- RENDER HELPERS ----
  const renderSidebar = () => {
    return (
      <>
        {years.map((y) => {
          const isYearActive = selectedYear === y.year;
          return (
            <Fragment key={y.year}>
              {/* ANNO */}
              <div
                className={`flex flex-col overflow-hidden rounded-lg shadow-lg mt-2 ${
                  isYearActive
                    ? "bg-indigo-200 text-indigo-800"
                    : "bg-white text-gray-900"
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (selectedYear === y.year) return;
                  setSelectedYear(y.year);
                  setSelectedMonth(null);
                  setBusteData([]); // svuota lista buste immediatamente in UI
                }}
              >
                <div className="flex flex-1 flex-col justify-between p-6">
                  <div className="flex-1">
                    <p className="text-xl font-semibold">{y.year}</p>
                    <p className="text-sm opacity-70">
                      {y.count} cedolin{y.count > 1 ? "i" : "o"}
                    </p>
                  </div>
                </div>
              </div>

              {/* MESI DELL'ANNO SELEZIONATO */}
              {isYearActive && (
                <>
                  {loadingMonths && (
                    <div className="py-4 w-full flex justify-center text-sm italic align-center">
                      <div className="flex items-center">
                        <svg
                          className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-indigo-600"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                        Caricamento...
                      </div>
                    </div>
                  )}

                  {!loadingMonths &&
                    monthsData.map((m) => {
                      const meseLabel =
                        months.find((mm) => mm.value === m.month)?.label ||
                        m.month;

                      const isMonthActive = selectedMonth === m.month;

                      return (
                        <Fragment key={`${y.year}-${m.month}`}>
                          <div
                            className={`flex flex-col overflow-hidden rounded-lg shadow-lg mt-2 ${
                              isMonthActive
                                ? "bg-indigo-100 text-indigo-800"
                                : "bg-white text-gray-900"
                            }`}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              if (selectedMonth === m.month) return;
                              setSelectedMonth(m.month);
                            }}
                          >
                            <div className="flex flex-1 flex-col justify-between p-4 ml-4">
                              <div className="flex-1">
                                <p className="text-lg font-semibold">
                                  {meseLabel}
                                </p>
                                <p className="text-xs opacity-70">
                                  {m.count} cedolin{m.count > 1 ? "i" : "o"}
                                </p>
                              </div>
                            </div>
                          </div>

                          {/* MOBILE: buste del mese attivo */}
                          {isMonthActive && (
                            <MonthBusteMobile
                              year={selectedYear}
                              month={selectedMonth}
                              monthLabel={meseLabel}
                              buste={busteData}
                              openPayrollId={openPayrollId}
                              toggleRow={toggleRow}
                              setSelectedDoc={setSelectedDoc}
                              handleConfirmDoc={handleConfirmDoc}
                              handleDeleteDoc={handleDeleteDoc}
                              deletePayrollConfirmed={deletePayrollConfirmed}
                              setPreviewDoc={setPreviewDoc}
                              loadingBuste={loadingBuste}
                              page={page}
                              totalPages={totalPages}
                              totalCount={totalCount}
                              onPageChange={setPage}

                              search={search}
                              setSearch={setSearch}

                              total={total}
                              showOnlyTotal={showOnlyTotal}
                              toConfirm={toConfirm}
                              confirmed={confirmed}
                              anyToConfirm={anyToConfirm}

                              fetchingReport={fetchingReport}
                              downloadReport={downloadReport}
                              handleConfirmAllDocs={handleConfirmAllDocs}
                              handleDeleteAllDocs={handleDeleteAllDocs}
                            />
                          )}
                        </Fragment>
                      );
                    })}
                </>
              )}
            </Fragment>
          );
        })}
      </>
    );
  };

  // pannello destro DESKTOP
  const renderRightPanelDesktop = () => {
    const meseLabel = months.find(
      (mm) => mm.value === selectedMonth
    )?.label;
    const headerLabel =
      selectedYear && selectedMonth
        ? `${selectedYear} - ${meseLabel || selectedMonth}`
        : selectedYear
          ? `${selectedYear} - Seleziona un mese`
          : "";

    return (
      <div className="px-4 py-6 sm:px-6 lg:pl-8 xl:flex-1 xl:pl-6 hidden xl:block">
        <div className="shadow-md bg-indigo-200 text-indigo-800 mt-2 flex justify-center text-xl font-semibold text-gray-900 py-6 rounded-lg min-h-[3rem]">
          {headerLabel}
        </div>
        <div className="mt-3">
          {/* Search box "card" */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 px-3 py-3">
            <TextField
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              placeholder="Cerca per cognome, nome o CF"
              size="small"
              fullWidth
              variant="outlined"
                  sx={{
                    minWidth: 320,

                    "& .MuiInputLabel-root": { color: "#6b7280" },
                    "&:hover .MuiInputLabel-root": { color: "#4338ca" },
                    "& .MuiInputBase-input-MuiOutlinedInput-input": { color: "#4338ca" },
                    "& .MuiInputLabel-root.Mui-focused": { color: "#4338ca" },

                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      backgroundColor: "#f9fafb",
                      height: 40,
                    },
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#c7d2fe", borderWidth: "1px" },
                    "& .MuiOutlinedInput-root:hover fieldset": { borderColor: "#818cf8", borderWidth: "1px" },
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#e5e7eb",
                      borderWidth: "1px",
                    },

                    "& .MuiOutlinedInput-input, & .MuiOutlinedInput-input:focus, & .MuiOutlinedInput-input:focus-visible": {
                      outline: "none",
                      boxShadow: "none",
                    },
                    "& .MuiOutlinedInput-root:focus-within": {
                      outline: "none",
                      boxShadow: "none",
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
            />

            {/* Summary pills */}
            <div className="mt-3 flex flex-wrap gap-2 uppercase">
              {/* Pill CARICATI (sempre visibile se total > 0) */}
              {total > 0 && (
                <div className="inline-flex items-center gap-2 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-100 px-3 py-1 text-xs font-semibold">
                  <span className="w-2 h-2 rounded-full bg-indigo-500" />
                  caricati: <span className="font-bold">{total}</span>
                </div>
              )}

              {/* Pills di dettaglio SOLO se necessario */}
              {!showOnlyTotal && (
                <>
                  <div className="inline-flex items-center gap-2 rounded-full bg-red-50 text-red-700 border border-red-100 px-3 py-1 text-xs font-semibold">
                    <span className="w-2 h-2 rounded-full bg-red-500" />
                    da confermare: <span className="font-bold">{toConfirm}</span>
                  </div>

                  <div className="inline-flex items-center gap-2 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-100 px-3 py-1 text-xs font-semibold">
                    <span className="w-2 h-2 rounded-full bg-emerald-500" />
                    confermati: <span className="font-bold">{confirmed}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>



        <div className="flex flex-col mt-2">
          <div className="align-middle min-w-full overflow-x-auto shadow overflow-hidden sm:rounded-lg">
            {loadingBuste ? (
              <div className="p-2 flex justify-center w-full">
                <LoadingState
                  spinnerSize={30}
                  label='Caricamento...' 
                  center={true}
                  fullWidth={true}
                  minHeight="auto"
                  className="inline-block align-middle border border-dashed rounded-md border-gray-300 py-2 italic"
                />
              </div>
            ) : (
              <>
                <ul role="list" className="divide-y divide-gray-100">
                  {busteData.map((busta) => (
                    <PayrollRow
                      key={busta.id}
                      busta={{
                        ...busta,
                        mese: busta.month,
                        anno: busta.year,
                      }}
                      isOpen={openPayrollId === busta.id}
                      onToggle={() => toggleRow(busta.id)}
                      onReassign={() =>
                        setSelectedDoc({
                          id: busta.id,
                          type: "payrolls",
                          employee: {
                            cf: busta.employee_cf,
                            first_name: busta.employee_first_name,
                            last_name: busta.employee_last_name,
                            name:
                              `${busta.employee_last_name || ""} ${
                                busta.employee_first_name || ""
                              }`.trim() || busta.employee_cf,
                          },
                        })
                      }
                      onConfirm={() =>
                        handleConfirmDoc({
                          id: busta.id,
                          type: "payrolls",
                        })
                      }
                      onDeleteUnconfirmed={() =>
                        handleDeleteDoc({
                          id: busta.id,
                          type: "payrolls",
                        })
                      }
                      onDeleteConfirmed={() =>
                        deletePayrollConfirmed(busta.id)
                      }
                      setPreviewDoc={setPreviewDoc}
                    />
                  ))}
                </ul>
                {selectedYear && selectedMonth && totalCount > 0 ? (
                  <div className="flex justify-center">
                    <PrettyPagination
                      page={page}
                      totalPages={totalPages}
                      totalCount={totalCount}
                      onChange={(value) => setPage(value)}
                      labelPlurale="cedolini"
                      className="mt-3 py-3 border border-t border-gray-200 bg-gray-50"
                    />
                  </div>
                ) : (
                  <div className="display-none"></div>
                )}
              </>
            )}
          </div>
        </div>

        {selectedYear && selectedMonth && (
          <div className="text-center mt-10 flex flex-wrap justify-around">
            {fetchingReport ? (
              <div className="flex items-center italic">
                <svg
                  className="inline w-4 h-4 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-indigo-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                Downloading...
              </div>
            ) : (
              <div className="grid grid-flow-col gap-3">
                <div className="d-flex justify-content-center sm:grid-cols-1 gap-1 w-full">
                  <button
                    onClick={downloadReport}
                    type="button"
                    className="grow inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 m-3 justify-center"
                  >
                    Stampa Report {selectedMonth}/{selectedYear}
                    <PaperClipIcon className="-mr-0.5 h-5 w-5" />
                  </button>
                </div>

                {anyToConfirm && (
                  <>
                    <div className="d-flex justify-content-center sm:grid-cols-1 gap-1 w-full">
                      <button
                        onClick={handleConfirmAllDocs}
                        type="button"
                        className="grow inline-flex items-center gap-x-1.5 rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 m-3 justify-center"
                      >
                        Conferma tutte {selectedMonth}/{selectedYear}
                        <CheckIcon className="-mr-0.5 h-5 w-5" />
                      </button>
                    </div>

                    <div className="d-flex justify-content-center sm:grid-cols-1 gap-1 w-full">
                      <button
                        onClick={handleDeleteAllDocs}
                        type="button"
                        className="grow inline-flex items-center gap-x-1.5 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 m-3 justify-center"
                      >
                        Cancella tutte {selectedMonth}/{selectedYear}
                        <TrashIcon className="-mr-0.5 h-5 w-5" />
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // ---------------------------------------------------------
  // RENDER PRINCIPALE
  // ---------------------------------------------------------

  if (fetchingYears) {
    return <Fetching />;
  }

  if (!fetchingYears && years.length === 0) {
    return (
      <div className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        <div role="status">
          <svg
            className="mx-auto h-12 w-12 text-gray-400"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 48 48"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 14v20c0 4.418 7.163 8 16 8 1.381 0 2.721-.087 4-.252M8 14c0 4.418 7.163 8 16 8s16-3.582 16-8M8 14c0-4.418 7.163-8 16-8s16 3.582 16 8m0 0v14m0-4c0 4.418-7.163 8-16 8S8 28.418 8 24m32 10v6m0 0v6m0-6h6m-6 0h-6"
            />
          </svg>
        </div>
        <span className="mt-2 block text-sm font-semibold text-gray-900">
          Non risultano presenti buste paga nel nostro database
        </span>
      </div>
    );
  }

  return (
    <div className="flex min-h-full flex-col">
      <ReassignDialog
        doc={selectedDoc}
        getDocs={async () => {
          // dopo riassegna ricarico mese corrente
          await refetchCurrentBuste();
          await refetchMonths();
          await refetchYears();
        }}
      />

      <div className="mx-auto w-full max-w-7xl grow lg:flex xl:px-2 max-h-100 overflow-y-auto">
        <div className="flex-1 xl:flex">
          {/* Sidebar anni/mesi (e su mobile le buste del mese attivo) */}
          <div className="border-b px-4 py-6 sm:px-6 lg:pl-2 xl:w-72 xl:shrink-0 xl:border-b-0 xl:pl-6">
            {renderSidebar()}
          </div>

          {/* Pannello destro DESKTOP */}
          {renderRightPanelDesktop()}
        </div>
      </div>

      <FilePreviewModal
        doc={previewDoc}
        onClose={() => setPreviewDoc(null)}
      />
    </div>
  );
}